export default "<p>\r\n  viewordervendor works!\r\n</p>\r\n"